import type { ComponentProps } from "react"

import {
	Avatar,
	SlackStyleMessage as BaseSlackStyleMessage,
} from "@productlane/ui"

import { MemberHoverCard } from "@/components/member-hover-card"

export const ANONYMOUS_SENDER_NAME = "Anonymous"

type Props = ComponentProps<typeof BaseSlackStyleMessage> & {
	/** Set when the author is a teammate, so the avatar opens the member card. */
	senderUserId?: string | null
}

export function SlackStyleMessage({ senderUserId, ...props }: Props) {
	const avatarContent =
		props.avatarContent ??
		(senderUserId ? (
			<MemberHoverCard userId={senderUserId}>
				<Avatar
					name={props.senderName ?? ANONYMOUS_SENDER_NAME}
					colorSeed={props.senderEmail}
					image={props.senderImage}
					size={props.avatarSize}
					roundness="full"
				/>
			</MemberHoverCard>
		) : undefined)

	return (
		<BaseSlackStyleMessage
			senderNameFallback={ANONYMOUS_SENDER_NAME}
			{...props}
			avatarContent={avatarContent}
		/>
	)
}
